module.exports = __webpack_public_path__ + "static/media/19ESCAP45.d1dc68f4.jpg";